import { Component, OnInit } from '@angular/core';
import { Errors, FooterService, LocalService } from '../../../core';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { CheckDateValidityPipe } from '../../pipe/check-date-validity.pipe';
import { CONSTANTS } from 'src/app/config';
import { filterUserRoles } from 'src/app/shared/utils/user.util';

@Component({
  selector: 'app-quiz',
  templateUrl: './quiz.component.html',
  styleUrls: ['./quiz.component.scss'],
  providers: [DatePipe]
})
export class QuizComponent implements OnInit {

  errors: Errors = { errors: {} };
  userData: any;

  // booleans 
  isNotAllowed: boolean = false;
  isIntro: boolean = false;
  isQuestion: boolean = false;
  isFailed: boolean = false;
  isFailedFinal: boolean = false;
  isPassed: boolean = false;
  isReview: boolean = false;
  isExpired: boolean = false;
  isQuizStatus: boolean = false;

  quizID: any;
  quizMetaInfo: any;
  quizData: any;
  selectedQuestion: any;
  questionIndex: number;
  selectedAnswers: any = [];
  answerText:any=[];
  quizResult: any;
  quizReview: any;
  quizBannerurl!: string;
  // chart properties 
  percentage!: number;
  subtitle!: string;
  color!: string;
  errorException: any;
  managerFlag:any;
  sellerFlag:any;

  constructor(
    private footerService: FooterService,
    private activatedRoute: ActivatedRoute,
    private datePipe: DatePipe,
    private sanitizer: DomSanitizer,
    private router: Router
  ) { }

  ngOnInit() {
    if (this.activatedRoute.snapshot.params['id']) {
      this.quizID = this.activatedRoute.snapshot.params['id'];      
      this.errorException = '';
      this.getQuizMetaInfo(this.quizID);
    } else {
      this.getQuizIdByDate();
    }
    this.userData = LocalService.get('userProfile');
    //this.getQuizMetaInfo();
    this.findRole();
  }
  
  getQuizIdByDate() {
    this.errorException = '';
    let today = new Date();    
    let quizId: any;
    let randomDate: any;
    randomDate = this.datePipe.transform(today, 'yyyy-MM-dd');
    this.footerService.getQuizIDbasedOnDate().subscribe((res: any) => {
      // this.quizBannerurl  = '/assets/images/bannerimg/Cisco_SellerRewards-indigo-rafting_1800x450.png';
      for (let prop in res) {
        if (prop == randomDate) {
          quizId = res[prop];
        }
      }
      if (quizId != undefined) {
        this.getQuizMetaInfo(quizId);
      }else {
        this.errorException = {
          "headMsg":"No Quizes",
          "bodyMsg":"There are no Quizes available currently"
        };
      }
    }, (error: any) => {
      // this.quizBannerurl = '/assets/images/bannerimg/Cisco_SellerRewards-indigo-rafting_1800x450.png'
    })
  }
 
  getQuizMetaInfo(quizId: any) {
    this.quizID = quizId;    
    this.footerService.getQuizMetaInfo(this.quizID).subscribe((data: any) => {    
      this.quizMetaInfo = data;
      this.checkConditions(data);
      // if (data.quiz.bannerImageName != null || data.quiz.bannerImageName != '') {
        if (data.quiz.bannerImageName != null) {
        this.quizBannerurl = `${data.quiz.bannerImageName}`; 
        // if('/assets/images/bannerimg/Cisco_SellerRewards-indigo-rafting_1800x450.png') {        
        //   this.quizBannerurl = '/assets/images/bannerimg/Cisco_SellerRewards-indigo-rafting_1800x450.png'
        // } else {
        //   this.quizBannerurl = '/assets/images/bannerimg/Cisco_SellerRewards-indigo-rafting_1800x450.png'
        // }
      }
      // else {
      //   if(`/assets/images/bannerimg/${data.quiz.bannerImageName}`) {
      //     this.quizBannerurl = `/assets/images/bannerimg/${data.quiz.bannerImageName}`; 
      //   }else{
      //     this.quizBannerurl = '/assets/images/bannerimg/Cisco_SellerRewards-indigo-rafting_1800x450.png'
      //   }
      // } 
    }, (err: any) => {
      this.errors = err;
      // this.quizBannerurl = '/assets/images/bannerimg/Cisco_SellerRewards-indigo-rafting_1800x450.png'
      if (err.status == '412 - PRECONDITION_FAILED') {
        this.errorException = {
          "headMsg":"NOT ALLOWED",
          "bodyMsg":"You are not allowed to access this quiz."
        };
      } else {
        this.errorException = {
          "headMsg":"No Quizes",
          "bodyMsg":"There are no Quizes available currently."
        };
      }
    });
  }

  checkConditions(data: any) {
    // if (!(new Date().getTime() <= new Date(data.quiz.endDate).getTime() && new Date().getTime() >= new Date(data.quiz.startDate).getTime())) {
    //   this.isQuizStatus = true;
    //   this.isExpired = true;     
    // }  
    if (!this.checkQuizValidity(data.quiz)) {
      this.isQuizStatus = true;
      this.isExpired = true;     
    }
    else if (data.status == '412 - PRECONDITION_FAILED') {
      this.isQuizStatus = true;
      this.isNotAllowed = true;
    } 
    else if (data.status == 'PASS') {
      this.isQuizStatus = true;
      this.isPassed = true;
      this.percentage = data.percentageAchieved;
      this.subtitle = 'SCORED';
      this.color = "#77DD77";
    }
    else if (data.status == 'FAIL') {
      this.isQuizStatus = true;
      this.percentage = data.percentageAchieved;
      this.subtitle = 'SCORED';
      this.color = "#FF6961";
      if (data.attemptCount >= data.quiz.allowedAttempts) {
        this.isFailedFinal = true;         
      }
      else {
        this.isFailed = true;         
      }
    }   
    else if (data.status == 'NEVER_TAKEN' || data.status == 'SAVED' || data.status == 'IN_PROGRESS') {
      this.isIntro = true;
    }
    // // old Code 
    // if (data.status == 'NEVER_TAKEN' || data.status == 'SAVED' || data.status == 'IN_PROGRESS') {
    //   this.isIntro = true;
    // }
    // else {
    //   this.isQuizStatus = true;
    //   // set pie chart values start
    //   if (data.status == 'PASS') {
    //     this.percentage = data.percentageAchieved;
    //     this.subtitle = 'SCORED';
    //     this.color = "#77DD77";
    //   }
    //   else {
    //     this.percentage = data.percentageAchieved;
    //     this.subtitle = 'SCORED';
    //     this.color = "#FF6961";
    //   }
    //   // set pie chart values end
    //   if (data.status == 'PASS') {
    //     this.isPassed = true;
    //   }
    //   else if (data.status == 'FAIL') {
    //     if (data.attemptCount >= data.quiz.allowedAttempts) {
    //       this.isFailedFinal = true;         
    //     }
    //     else {
    //       this.isFailed = true;         
    //     }
    //   }
    //   else if (data.status == '412 - PRECONDITION_FAILED') {
    //     this.isNotAllowed = true;
    //   }
    //   else if (!(new Date().getTime() <= new Date(data.quiz.endDate).getTime() && new Date().getTime() >= new Date(data.quiz.startDate).getTime())) {
    //     this.isExpired = true;
    //   }  
    //   // else if (data.status == 'IN_PROGRESS') {
    //   //   this.isSessionOpened = true;
    //   // }   
    // }
  }

  clearBooleans() {
    this.isQuizStatus = false;
    this.isExpired = false;
    this.isNotAllowed = false;
    this.isFailed = false;
    this.isFailedFinal = false;
    this.isPassed = false;    
    // isSessionOpened: boolean = false;  
  }

  getQuizData() {
    this.footerService.getQuizData(this.quizMetaInfo.quiz.id).subscribe((data: any) => {
      this.isIntro = false;
      this.clearBooleans();
      this.answerText=[];
      this.isQuestion = true;      
      // this.isQuizStatus = false;
      this.questionIndex = 0;
      this.quizData = data;
      this.selectedQuestion = this.quizData.questions[this.questionIndex];
      this.selectedQuestion.answerChoices.forEach((element: any) => {
        if (element.selected) {
          this.selectedAnswers.push(element.id);
        }
      });
    }, (err: any) => {
      this.errors = err;
    });
  }
  onAnswerSelect(event: any, q: any) {  
let questionData=this.selectedQuestion;
    if(questionData.type == 'TEXT'){
   
      this.quizData.questions.forEach((element: any) => {
        if (questionData.id == element.id) {
          element.answerChoices.forEach((element: any) => {
            if (element.id == q.id) element.selected = true;
            else element.selected = false;
          }); 
        }
      })
     // this.answerText.push(this.answetextField);
    }else
    if (questionData.type == 'SINGLE_ANSWER') {
      this.selectedAnswers = [];
      this.quizData.questions.forEach((element: any) => {
        if (questionData.id == element.id) {
          element.answerChoices.forEach((element: any) => {
            if (element.id == q.id) element.selected = true;
            else element.selected = false;
          });
        }
      });
      this.selectedAnswers.push(q.id);
    }
    else {
      if (event.checked) {
        this.quizData.questions.forEach((element: any) => {
          element.answerChoices.forEach((element: any) => {
            if (element.id == q.id) {
              element.selected = true;
            }
          });
        });
        this.selectedAnswers.push(q.id);
      }
      else {
        this.quizData.questions.forEach((element: any) => {
          element.answerChoices.forEach((element: any) => {
            if (element.id == q.id) {
              element.selected = false;
            }
          });
        });
        const index = this.selectedAnswers.indexOf(q.id);
        if (index > -1) {
          this.selectedAnswers.splice(index, 1);
        }
      }
    }
  }

  onPreviousQuestion() {
    this.selectedAnswers = [];
    this.questionIndex = this.questionIndex - 1;
    this.selectedQuestion = this.quizData.questions[this.questionIndex];
    this.selectedQuestion.answerChoices.forEach((element: any) => {
      if (element.selected) {
        this.selectedAnswers.push(element.id);
      }
    });
  }

  saveQuizAnswer(isLast: any) {
    let quizQuestionData=this.selectedQuestion;
    let params: any;

    if(quizQuestionData.type=='TEXT'){
       params = {
        questionId: this.selectedQuestion.id,
        answerText:this.answerText[this.questionIndex],  
        userId: this.userData.id
      }
    }else{

      params = {
        questionId: this.selectedQuestion.id,
        selectedAnswerChoiceIds:this.selectedAnswers,  
        userId: this.userData.id
      }
    }
   
    

    this.footerService.saveQuizAnswer(params).subscribe((data: any) => {     
      if (isLast) {
        this.submitQuiz();
      }
      else {
        this.selectedAnswers = [];
        this.questionIndex = this.questionIndex + 1;
        this.selectedQuestion = this.quizData.questions[this.questionIndex];
        this.selectedQuestion.answerChoices.forEach((element: any) => {
          if (element.selected) {
            this.selectedAnswers.push(element.id);
          }
        });
      }
    }, (err: any) => {
      this.errors = err;
    });
  }

  submitQuiz() {
    
    const params = {
      id: this.quizMetaInfo.quiz.id
    }
    this.footerService.submitQuiz(params).subscribe((data: any) => {
      this.quizResult = data;
      this.isQuestion = false; 
      this.selectedAnswers = [];
      this.clearBooleans();
      this.checkConditions(data);
    }, (err: any) => {
      this.errors = err;
    });
  }

  reviewQuiz() {
    const params = {
      quizId: this.quizMetaInfo.quiz.id,
      userId: this.userData.id
    }
    this.footerService.reviewQuiz(params).subscribe((data: any) => {
      this.quizReview = data;   
      this.clearBooleans();
      this.isReview = true;
    }, (err: any) => {
      this.errors = err;
    });
  }

  htmlProperty(html: any) {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  checkQuizValidity(quiz: any) {        
    let td = new Date();
    const currentDate = td.getFullYear() + '-' + Number(td.getMonth() + 1) + '-' + td.getDate();
    return CheckDateValidityPipe.prototype.transform(
      quiz.startDate.substring(0, 10), quiz.endDate.substring(0, 10), currentDate
    );
    // return (new Date().getTime() <= new Date(slide.endDate).getTime() && new Date().getTime() >= new Date(slide.startDate).getTime()); 
  } 

  findRole(){
    this.managerFlag = filterUserRoles(this.userData, CONSTANTS.manager).length > 0;
    this.sellerFlag = filterUserRoles(this.userData, CONSTANTS.seller).length > 0;
  }

  goToDashBorad(){    
    if (this.managerFlag) {
      return this.router.navigateByUrl('/home/manager/manage-challenges');
    }
    else if (this.sellerFlag) {
      return this.router.navigateByUrl('/home/seller/challenges');
    }else if((this.userData.hasOwnProperty('userType')&&this.userData.userType=='PAM')){
      return this.router.navigateByUrl('/home/manager/manage-challenges');
    }
  }

}
